// shared lead forms script
import "../../SharedSiteCode/Scripts/lead-forms";

// multistep form
$(document).ready(function () {
	if ($('.multi-step-form #lf-zip').is(':visible') && $('#lf-zip').val() == '') {
		const queryParams = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		if (queryParams.zip != null)
			$('#lf-zip').val(queryParams.zip).prop('readonly', true).parent().addClass('has-content');
	}

	if ($('.multi-step-form').length) {
		window.dataLayer = window.dataLayer || [];
		dataLayer.push({ 'event': 'goto-formpage-1' });
		$('.progress-bar').show();
		styleActiveFormStep();
		checkButtonVisibility(1, -1);

		$('.multi-step-form form').on('input keyup', function () {
			toggleNextButton();
		});
	}

	// nav buttons
	$('.multi-step-form #prev-page').on('click', function () {
		var $wrapper = $(this).closest('.multi-step-form');
		var $activePage = $('.page.active', $wrapper);

		if ($activePage.index() == 0) {
			window.history.back();
		}
		else {
			formScrollTop();
			var nPages = $wrapper.find('.page').length;
			var $prevPage = $activePage.css('position', '').removeClass('active').prev().css('display', 'block').css('left', '-100%'); // position previous page to the left
			var activeIndex = $prevPage.index() + 1;

			var percentComplete = ($prevPage.index() / nPages) * 100 + '%';
			$('.progress-bar .inner-bar').css('width', percentComplete);

			$('.form-pages').height($prevPage.outerHeight());
			checkButtonVisibility(activeIndex, nPages);

			setTimeout(function () {
				$prevPage.addClass('active').css('transform', 'translateX(100%)'); // slide in from the left
				$activePage.css('transform', 'translateX(100%)');
				$prevPage.css('left', '').css('position', 'static').css('transform', 'translateX(0)').on('transitionend', function () {
					$(this).off('transitionend'); // unbind or these will duplicate
					styleActiveFormStep();
				});
			}, 20);

			if (dataLayer !== undefined)
				dataLayer.push({ 'event': 'goto-formpage-' + activeIndex });
		}
	});

	$('.multi-step-form #next-page').on('click', function () {
		var $wrapper = $(this).closest('.multi-step-form');
		var $activePage = $('.page.active', $wrapper);

		$('.multi-step-form form').parsley().whenValidate({
			group: 'group-' + $activePage.index()
		}).done(function () {
			formScrollTop();
			var nPages = $wrapper.find('.page').length;
			var $nextPage = $activePage.css('position', '').removeClass('active').next().css('display', 'block').css('left', '100%'); // position next page to the right
			var activeIndex = $nextPage.index() + 1;

			var percentComplete = ($nextPage.index() / nPages) * 100 + '%';
			$('.progress-bar .inner-bar').css('width', percentComplete);

			$('.form-pages').height($nextPage.outerHeight());
			checkButtonVisibility(activeIndex, nPages);

			setTimeout(function () {
				$nextPage.addClass('active').css('transform', 'translateX(-100%)'); // slide in from the right
				$activePage.css('transform', 'translateX(-100%)');
				$nextPage.css('left', '').css('position', 'static').css('transform', 'translateX(0)').on('transitionend', function () {
					$(this).off('transitionend'); // unbind or these will duplicate
					styleActiveFormStep();
				});
			}, 20);

			if (dataLayer !== undefined)
				dataLayer.push({ 'event': 'goto-formpage-' + activeIndex });
		});
	});

	function gotoPage(targetPage) {
		var $wrapper = $('.multi-step-form');
		var $activePage = $('.page.active', $wrapper);
		var currentPage = $activePage.index();

		var steps = targetPage - currentPage;
		var $buttonToClick;

		if (steps > 0) {
			return; // short circuit to disallow skipping forward to avoid infinite loop on form:validate event (but saving code for future use)
			$buttonToClick = $('#next-page', $wrapper);
		} else {
			$buttonToClick = $('#prev-page', $wrapper);
			steps = Math.abs(steps);
		}

		function triggerClick() {
			if (steps > 0) {
				$buttonToClick.trigger('click');
				steps--;
				// delay before the next trigger to wait for intermediate page to load
				setTimeout(triggerClick, 500);
			}
		}

		triggerClick();
	}

	// jump to page if server error on earlier step
	$('[data-parsley-validate]').parsley().on('form:validated', function () {
		var firstErrorGroup = $(this.element).find('.parsley-error:first').attr('data-parsley-group');

		if (firstErrorGroup) {
			var pageNumber = parseInt(firstErrorGroup.replace('group-', ''), 10);
			gotoPage(pageNumber);
		}
	});

	// make enter go to next page of multistep form, or submit on last page
	$('.multi-step-form').on('keypress', function (e) {
		if (e.which == 13) {
			if ($('#next-page').is(':visible')) {
				e.preventDefault();
				$('#next-page').trigger('click');
            }
        }
	});

	// condition description
	$('.multi-step-form .condition-wrap .view-details').on('click', function (e) {
		e.stopPropagation(); // don't want to trigger label selection

		var $label = $(this).closest('label').toggleClass('description-visible');
		if ($label.hasClass('description-visible'))
			$(this).text('Close Description');
		else
			$(this).text('View Details');		
	});

	// validate zipcode depending on the selected state
	$('.multi-step-form #street_address, .multi-step-form #lf-state, .multi-step-form #lf-zip').on('keyup blur', function () {
		var stateCode = $('#lf-state').val();
		var zip = $('#lf-zip').val();
		var zipFieldInstance = $('#lf-zip').parsley();

		// Check if stateCode is not empty and zip is exactly 5 digits
		if (stateCode && zip.match(/^\d{5}$/)) {
			$.get(`/FormValidations/ValidateZipCode/?state=${stateCode}&zipCode=${zip}`, (result) => {
				zipFieldInstance.removeError('zipStateError'); // always clear error first to avoid stacking

				if (result) {
					$('#next-page').prop('disabled', false);
				} else {
					$('#next-page').prop('disabled', true);
					zipFieldInstance.addError('zipStateError', { message: "Oops! ZIP code doesn't match state." });
				}

				toggleNextButton();
			});
		}
	});

	// old text message opt-in
	//$('input[name="contact_preference"]').on('change', function () {
	//	if ($('#contact-pref-3').prop('checked'))
	//		$('.opt-in-msg').show();
	//	else
	//		$('.opt-in-msg').hide();
	//}).trigger('change');
});

function toggleNextButton(form) {
	form = form || $('[data-parsley-validate]');
	var nextButton = form.find('#next-page.btn');

	var $activePage = $('.page.active', form);
	var isValid = form.parsley().isValid({ group: 'group-' + $activePage.index(), view: 'none' }); // front end validation
	var errors = $activePage.find('.parsley-error'); // check if user changed field w/ server side error

	if (errors.length > 0) {
		isValid = false;
	}

	if (isValid) {
		nextButton.removeClass('button-disabled');
	} else {
		nextButton.addClass('button-disabled');
	}
}

function styleActiveFormStep() {
	toggleNextButton();

	$('.form-pages').css('height', 'auto');
	$('.form-pages .page.active').css('position', 'static').css('display', '');
	$('.form-pages .page:not(.active)').css({
		'position': '',
		'display': 'none'
	});
}

function checkButtonVisibility(activeIndex, nPages) {
	if (activeIndex == nPages) {
		$('.nav-buttons').addClass('last-page');
	}
	else {
		$('.nav-buttons').removeClass('last-page');
	}

	if (activeIndex == 1) {
		$('.nav-buttons').addClass('first-page');
	}
	else {
		$('.nav-buttons').removeClass('first-page');
	}
}

function formScrollTop() {
	var $header = $('.hero.homevestimate'); // account for sticky header space
	if ($header.length === 0) $header = $('header');

	var paddingTop = 24;
	var headerHeight = ($header.css('position') === 'sticky') ? $header.outerHeight() : 0;

	$('html, body').animate({ scrollTop: $('.multi-step-form').first().offset().top - headerHeight - paddingTop }, 500);
}